<style lang="scss">
@import '$vars';

.medical_record {
  @apply absolute flex right-0 pr-8 -mt-8 z-50;
  @screen mobile {
    @apply relative m-auto w-full justify-center mb-4
  }
  .modal-header>h2 {
    @apply mb-0;
  }
  .btn-transparent {
    @apply  border-blueAlt border-solid border-2 #{!important};
    &:hover {
      @apply text-blueAlt #{!important};
    }
  }
  ul {
    border-bottom-left-radius: 1.4em;
    border-bottom-right-radius: 1.4em;
  }
  .appointment_results {
    height: 300px;
  }
  label {
    text-transform: initial !important;
  }

  &__download-button {
    @apply border-2 border-solid border-green p-1 ml-2 w-6 h-6;

    &:hover {
      @apply border-green;
      background: lighten($color-green, 40%);
    }

    &:active, &:focus {
      @apply border-green;
    }
  }

  &__tooltip {
    @apply absolute bg-green text-white font-semibold p-2 rounded;
    bottom: calc(100% + 10px);
    font-size: 0.65rem;
    line-height: 1;
    right: 0;

    &::after {
      @apply absolute block;
      content: '';
      border: 5px solid transparent;
      border-top-color: var(--green);
      height: 0;
      right: calc(1.5rem / 2);
      top: 100%;
      width: 0;
    }
  }
}
</style>

<template>
  <section class="medical_record">
    <medical-record-modal
      v-if="selectedModal"
      :patient="patient"
      :full-medical-record="fullMedicalRecord"
      :selected-modal="selectedModal"
      @closed="selectedModal = false"
    />

    <div v-click-outside="() => showList = false">
      <button
        :class="showList? '!rounded-b-none !shadow-none' : ''"
        class="btn shadow-md btn-primary btn-md !p-1 !px-4 !h-6 !flex !items-center !justify-center !text-sm"
        @click="showList = !showList"
      >
        Solicitar prontuário &dtrif;
      </button>

      <ul
        v-if="showList"
        class="pt-2 pb-4 px-4 m-0 shadow-md list-none bg-white text-blue text-sm"
      >
        <li>
          <a @click="selectedModal = 'fullRecord'">
            Prontuário completo
          </a>
        </li>

        <li>
          <a @click="selectedModal = 'appointmentRecord'">
            Prontuário por consulta
          </a>
        </li>
      </ul>
    </div>

    <button
      v-if="fullMedicalRecord"
      :disabled="generatingPdf"
      class="btn medical_record__download-button relative"
      :class="{ 'cursor-not-allowed': generatingPdf }"
      @mouseenter="showTooltip = true"
      @mouseleave="showTooltip = false"
      @click="downloadRecord(fullMedicalRecord)"
    >
      <dr-icon
        width="15px"
        name="cloudDownload"
        fill="green"
      />

      <transition name="fade" mode="in-out">
        <div
          v-if="showTooltip"
          class="medical_record__tooltip"
        >
          Clique aqui para baixar o prontuário completo.
        </div>
      </transition>
    </button>
  </section>
</template>

<script>
import medicalRecordModal from '@/components/modals/medicalRecord'
import Axios from 'axios'

export default {
  name: 'MedicalRecordControls',

  components: {
    medicalRecordModal
  },

  props: {
    patient: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      showList: false,
      selectedModal: null,
      fullMedicalRecord: null,
      generatingPdf: false,
      showTooltip: false
    }
  },

  watch: {
    selectedModal () {
      this.period = {
        start: null,
        end: null
      }
    }
  },

  mounted () {
    const filters = [
      { query: 'filterAnd[mrd.type]', value: 'ALL' },
      { query: 'filterAnd[mrd.status]', value: 'SUCCESS' },
      { query: 'order[mrd.createdAt]', value: 'DESC' },
      {
        query: `filterAnd[mrd.${this.$route.params.patientType === 'specialPatient' ? 'specialPatient' : 'user'}]`,
        value: this.$route.params.id
      }
    ]

    const queryString = filters.reduce((acc, filter) => {
      if (filter.value) {
        return acc === '?'
          ? `${acc}${filter.query}=${filter.value}`
          : `${acc}&${filter.query}=${filter.value}`
      }

      return acc
    }, '?')

    const url = `/doctor/medical_record_download${queryString}`

    this.$http
      .get(url, this.$store.getters.getAuthHeader)
      .then((res) => {
        if (res.data.data.length > 0) {
          this.fullMedicalRecord = res.data.data[0]
        }
      })
  },

  methods: {
    downloadRecord (record) {
      if (!record) {
        return null
      }

      this.fn_SHOW_PROGRESS()
      this.generatingPdf = true

      const url = `${this.API_URL}/s3/file/medical_record_download/${record.uuid}/uuid`

      Axios.get(url, {
        headers: this.$store.getters.getAuthHeader.headers,
        responseType: 'blob'
      }).then(res => {
        const blob = new Blob([res.data], { type: 'application/pdf' })
        const href = URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = href
        link.download = `prontuario_${this.patient.name.replace(' ', '-')}_${this.$moment(record.created_at).format('DD-MM-YYYY')}.pdf`
        link.target = '_blank'
        link.click()
      })
        .catch((err) => this.fn_HANDLE_ERROR(err))
        .finally(() => {
          this.fn_HIDE_PROGRESS()
          this.generatingPdf = false
        })
    }
  }
}
</script>
